
import { Vue, Component } from 'vue-property-decorator';
import ShopService from '@/services/shop.service';
import lazyInject from '@/di';

@Component({
  components: {
  },
})
export default class UnbindShopModal extends Vue {
  @lazyInject(ShopService)
  private shopService!: ShopService;

  visible = false;

  text = '';

  shopId: number | string = '';

  handleCancel() {
    this.visible = false;
  }

  async submit() {
    const data = {
      shopId: this.shopId,
    };
    const res = await this.shopService.shopBossDisassociationAffirm(data);
    if (res) {
      this.$message.success('门店解绑成功');
      this.visible = false;
      this.$emit('refresh', true);
    }
  }

  async init(shopId: number | string) {
    const data = {
      shopId,
    };
    this.shopId = shopId;
    const res = await this.shopService.shopBossDisassociation(data);
    if (res) {
      this.text = res;
      this.visible = true;
    }
  }
}
